module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.6587/img/templates-homepage/stand-out-icon.svg"